module.exports = __webpack_public_path__ + "static/img/tips.60ed0de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tips.png
// module id = 1Ebi
// module chunks = 1